import { styled } from "@mui/material/styles";
import { Stack } from "@mui/material";
import { HubHookFormInput } from "../../components";

export const StyledContentStack = styled(Stack, {
  shouldForwardProp: (prop) => !["hasChildren"].includes(prop),
})(({ hasChildren }) => ({
  display: "grid",
  justifyItems: "center",
  height: "100%",
  width: "100%",
  gridTemplateColumns: hasChildren ? "1fr 0.5fr" : "1fr",
  gap: "15px",
}));

export const StyledGridStack = styled(Stack)({
  display: "grid",
  gridTemplateColumns: "repeat(4, 1fr)",
  gap: "15px",
});

export const StyledHubHookFormInput = styled(HubHookFormInput)({
  flexDirection: "row",
  "&.MuiFormControl-root": {
    flexDirection: "row",
  },
});

export const InfoStack = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  gap: "10px",
  alignItems: "center",
  padding: "10px 15px",
  width: "100%",
  borderRadius: "7px",
  border: "1px solid",
  borderColor: theme.palette.hubColors.blueMain,
  backgroundColor: theme.palette.hubColors.blueMainTransparent,
  color: theme.palette.hubColors.blueMain,
  svg: {
    width: "18px",
    height: "18px",
    // strokeWidth: 2.5,
  },
  ".MuiTypography-root": {
    lineHeight: "14px",
  },
}));
